import { Modal } from "react-bootstrap";
import useStore from "../hooks/useStore";
import useFlow from "../hooks/useFlow";

export default function PlansOfferModal() {
  const {
    showPlansOfferModal,
    setShowPlansOfferModal,
    setSelectedPopularItem,
    setShowPopularItemModal,
  } = useStore();

  const { locationPreferences } = useFlow();

  const handleClose = () => setShowPlansOfferModal(false);

  const handleBuy = (item) => {
    if (!item) return;
    setSelectedPopularItem(item);
    handleClose();
    setShowPopularItemModal(true);
  };

  return (
    <Modal
      show={showPlansOfferModal}
      onHide={handleClose}
      centered
      size="xl"
    >
      {locationPreferences?.planOffer && (
        <Modal.Body className="text-center p-4 offerModal">
          <div className="row offers no-gutters col-md-offset-2 pt-1 justify-content-center">
            <div className="col-md-12">
              <h2 className="py-4" style={{ fontWeight: 300 }}>
                How would you like to pay?
              </h2>
            </div>

            <div className="col-12 text-white px-2 py-4 sale-box">
              <a
                className="text-white text-decoration-none get-package"
                role="button"
                from="class"
                data-testid="plans-special-btn"
                onClick={() =>
                  handleBuy(locationPreferences?.planOffer?.special)
                }
              >
                <div
                  className="row g-0 bg-danger"
                  style={{ borderRadius: "15px" }}
                >
                  <div
                    className="col-md-3 bg-primary d-flex align-items-center text-center"
                    style={{
                      borderBottomLeftRadius: "15px",
                      borderBottomRightRadius: "0px",
                      borderTopLeftRadius: "15px",
                      borderTopRightRadius: "0px",
                    }}
                  >
                    <h3 className="p-0 m-0 w-100">Special</h3>
                  </div>
                  <div className="col px-4">
                    <div className="row justify-content-center align-self-center">
                      <div className="col-2">
                        <b style={{ fontSize: "calc(30px + 1.5vmax)" }}>
                          <small
                            className="fw-light"
                            style={{
                              position: "relative",
                              top: "-10px",
                            }}
                          >
                            $
                          </small>
                          {locationPreferences.planOffer?.special?.price}
                        </b>
                      </div>

                      <div className="col rounded d-flex align-items-center text-start">
                        <h4 className="p-0 m-0 fw-light">
                          {locationPreferences.planOffer?.special?.name}
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </div>

            {locationPreferences.planOffer?.others?.map((item, index) => (
              <div
                className="col-12 col-md-4 p-2 pointer"
                data-testid="plans-other-btn"
                onClick={() => handleBuy(item)}
                key={index}
              >
                {item && (
                  <div className="bg-light py-5 px-2 get-package shadow-sm rounded-4 border">
                    <h4>
                      <b>{item?.name} </b>
                    </h4>
                    <p>
                      <small>$</small>
                      <span className="fs-3">{item?.price}</span>
                    </p>
                    <span className="btn btn-outline-primary btn-lg mt-4">
                      {" "}
                      Learn More
                    </span>
                  </div>
                )}
              </div>
            ))}

            {locationPreferences?.planOffer?.small && (
              <div
                className="col-12 col-md-12 p-2 pointer"
                data-testid="plans-small-btn"
                onClick={() => handleBuy(locationPreferences?.planOffer?.small)}
              >
                <a className="btn btn-light btn-lg mt-4 get-package">
                  ${locationPreferences.planOffer?.small?.price}{" "}
                  {locationPreferences.planOffer?.small?.name}
                </a>
              </div>
            )}
          </div>
        </Modal.Body>
      )}
      <Modal.Footer className="border-0 p-4">
        <a
          className="pointer"
          data-testid="plans-cancel-btn"
          onClick={handleClose}
          style={{
            color: "inherit",
            textDecoration: "none",
          }}
        >
          Cancel
        </a>
      </Modal.Footer>
    </Modal>
  );
}
